import { useState } from 'react'
import CrossIcon from '../assets/cross.svg'
import { Button } from '@/ui/Button'
import styles from './ControlSheetDeleteButton.module.scss'
import { useDismiss, useFloating, useInteractions } from '@floating-ui/react'

interface Props {
    deleteAction: () => void
}

export const ControlSheetDeleteButton = ({ deleteAction }: Props) => {
    const [showDelete, setShowDelete] = useState(false)

    // Use Floating UI's useDismiss for handling outside clicks
    const { refs, context } = useFloating({
        open: showDelete,
        onOpenChange: setShowDelete,
    })
    const dismiss = useDismiss(context, {
        outsidePress: true,
        escapeKey: true,
        ancestorScroll: true,
    })
    const { getFloatingProps } = useInteractions([dismiss])

    const handleCrossClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation() // Prevent parent div click
        setShowDelete(true)
    }

    const handleDeleteClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation() // Prevent parent div click
        deleteAction()
    }

    return (
        <div ref={refs.setFloating} {...getFloatingProps()} className={styles.container}>
            {showDelete ? (
                <Button variant={'tertiary'} rounded={true} onClick={handleDeleteClick} size={'small'}>
                    Delete
                </Button>
            ) : (
                <button onClick={handleCrossClick} className={styles.iconContainer}>
                    <CrossIcon />
                </button>
            )}
        </div>
    )
}
